export default "__VITE_ASSET__yyY8z7jB__"